module.exports = __webpack_public_path__ + "static/media/inf_15og16.858b1b9e.mp3";